import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {INavigation} from './navigation.interface';
import {environment} from '../../environments/environment';
import {Locale} from "../core/lang.enum";

@Injectable()
export class NavigationService {
  constructor(private http: HttpClient) {
  }

  list(): Observable<INavigation[]> {
    return this.http.get<INavigation[]>(`${environment.apiEndpoint}/navigation`);
  }

  one(id: INavigation['id'], locale: Locale): Observable<INavigation> {
    return this.http.get<INavigation>(`${environment.apiEndpoint}/navigation/${id}`, {
      params: {locale}
    });
  }

  update(id: INavigation['id'], body: Partial<INavigation>): Observable<INavigation> {
    return this.http.put<INavigation>(`${environment.apiEndpoint}/navigation/${id}`, body);
  }

  create(body: Partial<INavigation>): Observable<INavigation> {
    return this.http.post<INavigation>(`${environment.apiEndpoint}/navigation`, body);
  }

  delete(id: INavigation['id']): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/navigation/${id}`);
  }
}
